/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ChequeCuentaModeloMLS { 
    codigo?: string;
    bancoEmisor?: string;
    cuenta?: string;
    valor?: number;
    estado?: string;
    documento?: string;
    usuario?: string;
    fechaIngreso?: string;
    fechaMaquinaIngreso?: string;
    transaccion?: string;
    fechaEfectivizacion?: string;
}